module.exports = __webpack_public_path__ + "img/exceeding-variables-bar.9c2062c4.svg";